import React, { useState } from "react";
import { useNavigate } from "react-router-dom"

import back from "../../Assets/loginback.png";
import logo from "../../Assets/logo.png";

import { useDispatch } from "react-redux"
import { addUser } from "../../GlobalStore/actions/userAction"
import { loginAPI } from "../../API/Auth"
import { ToastContainer, toast } from 'react-toastify';

import "./Login.scss";





const Login = () => {
  let navigate = useNavigate()
  let dispatch = useDispatch()

  const [enteredData, setEnteredData] = useState({
    email: "",
    password: ""
  })

  const enteringData = (event) => {
    let { name, value } = event.target
    setEnteredData((preVal) => {
      return {
        ...preVal,
        [name]: value
      }
    })
  }

  const loginUser = async () => {
    if (!enteredData.email || !enteredData.password) {
      toast.warn('Please Enter Email & Password', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      let res = await loginAPI(enteredData)
      if (res.error != null) {
        toast.error(res.error, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        dispatch(addUser(res.data.data))
        toast.success(res.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        navigate("/dashboard")
      }
    }
  }

  return (
    <div className="main_login">
      <div className="back_img">
        <img src={back} />
      </div>
      <div className="transparent"></div>
      <div className="left_mail">
        <div className="mail_content">
          <img src={logo} />
          <div className="title">Sign In</div>
          <input type="email" name="email" onChange={enteringData} value={enteredData.email} placeholder="Enter Your Email" />
          <input type="Password" name="password" onChange={enteringData} value={enteredData.password} placeholder="Enter Your Password" />
          <button onClick={loginUser}>Log In</button>
          <p>
            Don't have an account?<span onClick={() => navigate("/signup")}>Sign up</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
